var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgStacks = function SvgStacks(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Stacks' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0 L48,0 L48,26 L42.001,26 L42.001,31.999 L36,31.999 L36,38 L0,38 L0,12 L6.001,12 L6.001,5.999 L12,5.999 L12,0 Z M14.001,2 L14.001,5.999 L42.001,5.999 L42.001,23.999 L46,23.999 L46,2 L14.001,2 Z M8,8 L8,12 L36,12 L36,30 L40,30 L40,8 L8,8 Z M2,36 L34,36 L34,13.999 L2,13.999 L2,36 Z"
  }));
};
SvgStacks = pure(SvgStacks);
SvgStacks.displayName = 'SvgStacks';
export default SvgStacks;